/* eslint-disable sort-keys */
import {
    AGING_TANK,
    APPELLATION,
    COLOR,
    COUNTRY,
    DRINK_CATEGORY,
    GRAPE_CONTENT,
    MANUFACTURER,
    NET_VOLUME,
    REGION,
    STORAGE_CAPACITY,
    STRONGNESS,
    SUGAR_TYPE,
    TEMPERATURE_FROM,
    TEMPERATURE_TO,
    YEAR,
} from 'modules/product-card/constants/characteristics';

const HEADER = [COLOR, COUNTRY, REGION, SUGAR_TYPE, GRAPE_CONTENT, MANUFACTURER, STRONGNESS, NET_VOLUME];
const DETAILED = [
    REGION,
    APPELLATION,
    DRINK_CATEGORY,
    AGING_TANK,
    YEAR,
    STORAGE_CAPACITY,
    TEMPERATURE_FROM,
    TEMPERATURE_TO,
];
const TABLET = [...HEADER, ...DETAILED];

export const SHAMPANSKOE_CHARACTERISTICS = {
    HEADER,
    DETAILED,
    TABLET,
};
